import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_PHARMACY_POPULAR_PRODUCTS } from "../../action-types/actions";

import i18n from "../../i18n";
export const getPharmacyPopularProducts = createAsyncThunk(
  ACTIONS_PHARMACY_POPULAR_PRODUCTS.get_pharmacy_popular_products,
  async ({ date_from, date_to, limit = 10 }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyPopularProducts}`,
        { params: { date_from, date_to, limit } },
      );
      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("pharmacy.toast.failedToFetchPopularProducts");
      return rejectWithValue(errMsg);
    }
  },
);
